/**
 * The Crave logo.
 *
 * Both files are generated from the source art by `npm run brand:build`; the
 * light variant is the same wordmark tinted white for dark backgrounds.
 *
 * @param {object} props
 * @param {number} [props.height] Rendered height in px. Width follows the aspect ratio.
 * @param {'ink'|'light'} [props.variant] `light` for placing on a dark surface.
 * @param {import('react').CSSProperties} [props.style]
 */
export function Wordmark({ height = 18, variant = 'ink', style }) {
  const src = variant === 'light' ? '/brand/crave-wordmark-light.png' : '/brand/crave-wordmark.png';

  return (
    <img
      src={src}
      alt="Crave"
      height={height}
      // The generated asset is 640x153.
      width={Math.round((height * 640) / 153)}
      style={{ display: 'block', height, width: 'auto', ...style }}
    />
  );
}
